import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseReviewInfo.module.scss'

const cx = className.bind(style)

type Props = {
  reviewCount?: any
}

const MyhouseResidentInfo: React.FC<Props> = ({ reviewCount }: Props) => {
  return (
    <div className={cx('myhouse_resident_info')}>
      <div className={cx('myhouse_resident_inner')}>
        <span className={cx('myhouse_resident_title')}>
          총 <em className={cx('myhouse_resident_count')}>{reviewCount}</em>개의 리뷰가 등록되었습니다.
        </span>
        <p className={cx('myhouse_resident_description')}>리뷰는 우리 단지 주민 뿐만 아니라 네이버페이 부동산 이용자들에게도 노출됩니다.</p>
      </div>
    </div>
  )
}

export default MyhouseResidentInfo
